var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50976 3.51814C1.41353 3.2978 1.36011 3.05444 1.36011 2.79867C1.36011 1.80526 2.16537 1 3.15878 1C4.15218 1 4.95745 1.80526 4.95745 2.79867C4.95745 2.92188 4.94503 3.04221 4.92147 3.1584",
    stroke: "#878787",
    strokeWidth: 0.539601,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.698 3.96777L4.90905 4.18793C5.32256 4.26311 5.58373 4.67519 5.47545 5.08115L5.04701 6.72837C4.99287 6.93126 4.82613 7.08432 4.61946 7.12066L3.66095 7.28973C3.5203 7.31455 3.37838 7.25376 3.29906 7.13505L3.03699 6.74204C2.93986 6.59652 2.8136 6.47278 2.66611 6.3787L1 5.31677C1.04461 4.78257 1.59554 4.44586 2.09125 4.64982L2.6188 4.8671V2.79863C2.6188 2.50059 2.86036 2.25903 3.1584 2.25903C3.45644 2.25903 3.698 2.50059 3.698 2.79863V3.96777Z",
    stroke: "#878787",
    strokeWidth: 0.539601,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.c85b3b7a6bdd2e9494e4404d72608a9b.svg";
export { ForwardRef as ReactComponent };